export const getBlur = (px: number) => `blur(${px}px)`;